import { FC } from 'react';

type Props = {
	className?: string;
};

const Delete_02_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M16.0001 4.7998L15.5044 12.82C15.3776 14.869 15.3143 15.8936 14.8007 16.6302C14.5467 16.9944 14.2199 17.3018 13.8407 17.5327C13.0738 17.9999 12.0473 17.9999 9.99422 17.9999C7.93853 17.9999 6.91067 17.9999 6.14326 17.5318C5.76386 17.3005 5.43681 16.9926 5.18296 16.6278C4.66951 15.89 4.60757 14.864 4.48369 12.812L4 4.7998'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M2.80078 4.80003H17.2009M13.2454 4.80003L12.6994 3.6734C12.3366 2.92502 12.1551 2.55082 11.8422 2.31745C11.7729 2.26568 11.6993 2.21963 11.6225 2.17976C11.276 2 10.8601 2 10.0285 2C9.17588 2 8.74964 2 8.39738 2.1873C8.31932 2.22881 8.24482 2.27672 8.17467 2.33054C7.85814 2.57337 7.68133 2.96125 7.32771 3.73702L6.84316 4.80003'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M8 13.5999V8.7998'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M12 13.5999V8.7998'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export default Delete_02_Icon;
